import React from 'react'
import styles from "../../utilities/OurMap/Map.module.css"
const OurMap = () => {
    return (
        <div className={styles.mapMain}>
            <div className={styles.Our_Img}>
                <img src='images/Our_story_map2.webp' alt='map-image' />
                <div className={styles.mapContent}>
                    <div className={styles.mapHistory}>
                        <h2>Proudly Italian a 26 year history as a multinational pharma company</h2>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default OurMap
